import { ownerSetLocalProducts, useOwnerDetails } from 'api/owners';
import React, { useCallback, useState } from 'react';
import { Checkbox } from 'ui-kit';
import { message } from 'antd';
import Wrapper from 'components/Wrapper';

export interface IStoreDetailsForm {
  ownerId: number;
  initialIsLocalProductsDisabled: boolean;
}

const StoreDetailsForm = ({ ownerId, initialIsLocalProductsDisabled }: IStoreDetailsForm) => {
  const [isLocalProductsDisabled, setLocalProductsDisabled] = useState(
    initialIsLocalProductsDisabled,
  );

  const { invalidate } = useOwnerDetails(ownerId);

  const toggleLocalProductsSet = useCallback(() => {
    const payload = {
      isLocalProductOptedOut: !isLocalProductsDisabled,
    };

    ownerSetLocalProducts(payload)
      .then((res) => {
        if (res.ok) {
          const isLocalProductOptedOut = res.data.isLocalProductOptedOut;
          setLocalProductsDisabled(isLocalProductOptedOut);
          invalidate();
          message.success(
            isLocalProductOptedOut ? 'Inactive local vendors' : 'Active local vendors',
          );
        } else {
          message.error(res.data || 'Error updating vendor activity');
        }
      })
      .catch((e) => {
        // eslint-disable-next-line no-console
        console.log(e);
      });
  }, [isLocalProductsDisabled, invalidate]);

  return (
    <Wrapper className="hc-settings">
      <Checkbox id="all" onChange={toggleLocalProductsSet} checked={isLocalProductsDisabled}>
        Start new local vendors as default inactive in <strong>all stores</strong>
      </Checkbox>
    </Wrapper>
  );
};

export default StoreDetailsForm;
